import { render, staticRenderFns } from "./Oblast.vue?vue&type=template&id=36601fc4&scoped=true&"
import script from "./Oblast.vue?vue&type=script&lang=js&"
export * from "./Oblast.vue?vue&type=script&lang=js&"
import style0 from "./Oblast.vue?vue&type=style&index=0&id=36601fc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36601fc4",
  null
  
)

export default component.exports